import React from 'react'
import '../Footer/Footer.css';
import { FaWhatsapp, FaTwitter, FaFacebook, FaInstagram } from "react-icons/fa";


export const Footer = () => {
  return (
    <div className='footer'>

        <div className='footpara'>
          <h1>Shop With us</h1>
          <p>Lorem ipsum dolor amet consectetur adipisicing  Asperiores ullam deleniti perspiciatis aut animi quam labore earum sequi esse itaque et, ea explicabo </p>
          <div className="social-icons">
          <i><FaWhatsapp /></i><i><FaFacebook /></i><i><FaTwitter /></i><i><FaInstagram /></i>
          </div>
        </div>


        <ul>
            <h1>SHOP</h1>
            <li>Luggage</li>
            <li>Backpacks</li>
            <li>Hard Luggage</li>
            <li>Soft Luggage</li>
            <li>Blog</li>
            <li>Store Locator</li>
        </ul>

        <ul>
            <h1>POLICIES</h1>
            <li>Privacy policy</li>
            <li>Returns & Exchanges</li>
            <li>Shipping policy</li>
            <li>Terms & Conditions</li>
            <li>Warranty policy</li>
            <li>SUPPORT</li>
        </ul>


        <ul>
            <h1>Quick Links</h1>
            <li>About Us</li>
            <li>Contact us</li>
            <li>Account</li>
            <li>Terms & Conditions</li>
            <li>Warranty</li>
            <li>Return Request</li>
        </ul>
    </div>
  )
}
